import queryString from 'query-string';
import request from '@meitu/saas-editor-ui/es/request';
import { getWebApiHostname } from '@/utils/request';
import {
    ICommitTagParams,
    IMaterialLayerTagInfoResponse,
    IMaterialListParams,
    ITagedListResponse,
    ITagListResponse,
} from './index.d';

/**
 * 获取标签列表
 *
 * api-mock: https://api-mock.meitu-int.com/project/2110/interface/api/137695
 */
export const getTagList = async function () {
    return await request<ITagListResponse>(`${getWebApiHostname()}/v1/material_layer/tag_list`, {
        method: 'GET',
    });
};

/**
 *
 * api-mock: https://api-mock.meitu-int.com/project/2110/interface/api/137774
 */
export const updateTag = async function (params: ICommitTagParams) {
    return await request<any>(`${getWebApiHostname()}/v1/material_layer/update`, {
        method: 'POST',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
        transformRequest: [
            function (data) {
                data = JSON.stringify(data);
                return data;
            },
        ],
    });
};

/**
 * 提交打标
 *
 * api-mock: https://api-mock.meitu-int.com/project/2110/interface/api/137129
 */
export const commitTag = async function (params: ICommitTagParams) {
    const queryParams: any = queryString.parse(window.location.search);
    if (params.id || queryParams.material_id) {
        return updateTag(params);
    }

    return await request<any>(`${getWebApiHostname()}/v1/material_layer/tagging`, {
        method: 'POST',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
        transformRequest: [
            function (data) {
                // Do whatever you want to transform the data
                data = JSON.stringify(data);
                return data;
            },
        ],
    });
};

/**
 *
 * api-mock: https://api-mock.meitu-int.com/project/2110/interface/api/137783
 */
export const getMaterialLayerTagInfo = async function (tagId: string) {
    return await request<IMaterialLayerTagInfoResponse>(`${getWebApiHostname()}/v1/material_layer/info`, {
        method: 'GET',
        params: {
            id: tagId,
        },
    });
};

/**
 *
 * api-mock: https://api-mock.meitu-int.com/project/2110/interface/api/137918
 */
export const getMaterialLayerTaggedList = async function (templateId: string) {
    return await request<ITagedListResponse>(`${getWebApiHostname()}/v1/material_layer/tagged_list`, {
        method: 'GET',
        params: {
            material_id: templateId,
        },
    });
};

/**
 *
 * api-mock: https://api-mock.meitu-int.com/project/2110/interface/api/137783
 */
export const getMaterialLayerInfoById = async function (tagId: string, material_id?: string) {
    return await request<any>(`${getWebApiHostname()}/v1/material_layer/info`, {
        method: 'GET',
        params: {
            id: tagId,
            material_id,
        },
    });
};

/**
 *
 * api-mock: https://api-mock.meitu-int.com/project/2110/interface/api/138442
 */
export const getMaterialList = async function (params: IMaterialListParams) {
    return await request<any>(`${getWebApiHostname()}/v1/material_layer/list`, {
        method: 'GET',
        params,
    });
};

export const getBgMaterialList = async function (params: IMaterialListParams) {
    return await request<any>(`${getWebApiHostname()}/v1/material_layer/background_list`, {
        method: 'GET',
        params,
    });
};

export const materialLayerSearch = async (search: string) => {
    return await request<any>(`${getWebApiHostname()}/v1/material_layer/search`, {
        method: 'GET',
        params: {
            keyword: search,
        },
    });
};

export const searchMaterialLayer = async (keyword: string, title: string, subTitle: string) => {
    return await request<any>(`https://betawebapi-pc.meitu.com/v1/material_layer/matched_list`, {
        method: 'GET',
        params: {
            desc: keyword,
            title,
            subtitle: subTitle,
        },
    });
};

// /v1/material_layer/search_tag https://api-mock.meitu-int.com/project/2110/interface/api/146134
export const searchMaterialLayerByTag = async (keyword: string, material_type: string, search_mode?: number) => {
    return await request<any>(`https://betawebapi-pc.meitu.com/v1/material_layer/search_tag`, {
        method: 'GET',
        params: {
            keyword,
            material_type,
            search_mode,
        },
    });
};
